import {
  Box,
  Card,
  CardContent,
  Grid,
  Hidden,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import CustomerRegistrationForm from "./components/CustomerRegistrationForm";

import AuthPage from "../../Components/AuthPage";

const CustomerRegistration = () => {
  const theme = useTheme();

  return (
    <AuthPage title="Customer Registration">
      <Box
        sx={{
          // height: "auto",
          // pb: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography variant="h4" gutterBottom>
            Welcome to Digital SACCO, <br /> Membership Registration.
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            Enter your details below.
          </Typography>
        </Box>

        <Box>
          <CustomerRegistrationForm />
        </Box>
      </Box>
    </AuthPage>
  );
};

export default CustomerRegistration;
